import { createFileRoute } from '@tanstack/react-router'
import { WebLayout } from '@/components/layout'
import { ContactPage } from '@/features/contact'

export const Route = createFileRoute('/contact')({
  component: ContactPageRoute,
})

function ContactPageRoute() {
  return (
    <WebLayout>
      <ContactPage />
    </WebLayout>
  )
}
